import React from "react";
import TagList from "components/Tags/TagList";
import TypeAhead from "../TypeAhead";

import SubMarketNeighborhoodListItem from "./SubMarketNeighborhoodListItem";
import {
  market_market_submarkets,
  market_market_submarkets_neighborhoods,
} from "../types/market";

type Props = {
  subMarkets: market_market_submarkets[];
  onNeighborhoodChange: (
    neighborhood: market_market_submarkets_neighborhoods,
    checked: boolean
  ) => void;
  onSubmarketChange: (
    sMarket: market_market_submarkets,
    checked: boolean
  ) => void;
  selectedNeighborhoods: market_market_submarkets_neighborhoods[];
  allNeighborhoods: market_market_submarkets_neighborhoods[];
  selectedSubmarkets: market_market_submarkets[];
};

const SubMarketNeighborhoodSelector = ({
  subMarkets,
  onNeighborhoodChange,
  onSubmarketChange,
  selectedNeighborhoods,
  allNeighborhoods,
  selectedSubmarkets,
}: Props) => {
  const onNeighborhoodCheck = (
    checked: boolean,
    neighborhood: market_market_submarkets_neighborhoods
  ) => {
    onNeighborhoodChange(neighborhood, checked);
  };

  const allUnselectedNeighborhoods = allNeighborhoods.filter(
    (nhood) =>
      !selectedNeighborhoods.some(
        ({ externalId }) => nhood.externalId === externalId
      )
  );

  return (
    <div>
      <TypeAhead
        predictableItems={allUnselectedNeighborhoods}
        onItemClick={(item) =>
          onNeighborhoodChange(item, !selectedNeighborhoods.includes(item))
        }
      />
      <TagList
        tags={selectedNeighborhoods}
        displayKey="name"
        onRemove={(id) => {
          const nhoodToRemove = selectedNeighborhoods.find(
            (nhood) => nhood.id === id
          );
          if (nhoodToRemove)
            onNeighborhoodChange(
              nhoodToRemove,
              false // always unchecked from this control
            );
        }}
      />

      <div data-qa="sub-market-neighborhood-list">
        {subMarkets.map((subMarket) => (
          <SubMarketNeighborhoodListItem
            key={subMarket.id}
            subMarket={subMarket}
            onSubMarketChange={onSubmarketChange}
            onNeighborhoodCheck={onNeighborhoodCheck}
            selectedNeighborhoods={selectedNeighborhoods}
            isChecked={
              !!selectedSubmarkets.find(
                (sm) => sm.externalId === subMarket.externalId
              )
            }
          />
        ))}
      </div>
    </div>
  );
};

export default SubMarketNeighborhoodSelector;
